import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

export default function HitPayRibbon({
  isMobile,
  className = '',
  style = {},
  title = 'HitPay Payment',
  iconSrc = '/hitpay-logo-14px.svg',
  iconSize = 14,
}) {
  const getResponsiveClass = () => {
    if (isMobile === true) return 'hitpay-ribbon--mobile'
    if (isMobile === false) return 'hitpay-ribbon--desktop'
    return ''
  }

  return (
    <div
      className={`hitpay-ribbon ${getResponsiveClass()} ${className}`.trim()}
      style={style}
      title={title}
    >
      <img
        src={iconSrc}
        alt="HitPay"
        className="hitpay-ribbon-icon"
        style={{ width: iconSize, height: iconSize }}
      />
    </div>
  )
}

HitPayRibbon.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  iconSrc: PropTypes.string,
  iconSize: PropTypes.number,
}
